import React, { useEffect, useState } from 'react';
import SideBar from './SideBar';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Loader from '../components/Loader';
import { ToastContainer } from 'react-toastify';
import DraggableSidebar from '../components/DraggableSidebar';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { show as sectinDetail } from '../Store/api/sections';
export const TeacherAssistantInvite = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const emailExist = searchParams.get('existInDB');
  const sectionId = searchParams.get('sectionId');
  const urlParams = new URLSearchParams(window.location.search);
  const searchParamsString = urlParams.toString();
  localStorage.setItem('searchParams', searchParamsString);
  const { id } = useParams();
  const [sectionData, setSectionData] = useState({
    createdBy: {
      firstName: ''.toLowerCase(),
      lastName: ''.toLowerCase(),
    },
  });

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { token: userToken } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(
      sectinDetail({
        id: sectionId,
        onSuccess: (res) => {
          setSectionData(res.data.data);
        },
      })
    );
  }, [sectionId]);

  useEffect(() => {
    setTimeout(() => {
      if (userToken) {
      } else if (emailExist === 1) {
        navigate('/teacherassistantsignin', {
          state: { sectionId: id },
        });
      } else if (emailExist === 0) {
        navigate('/TeacherAssistantSignup');
      }
    }, 5000);
  }, []);

  return (
    <div className='flex-container'>
      <div
        // className="col-xxl-1 col-xl-1 col-lg-12 col-md-12 px-0"
        className='activity-spectrum'
      >
        <div>
          <DraggableSidebar
          /*  scrollBook={scrollToSection}
                  scrollCentre={scrollWithSpectrum} */
          />
        </div>
      </div>
      <div style={{ width: '97.9%' }}>
        <section className='class_room_wrap'>
          <div className='custom_container'>
            <div className='row'>
              <div className='col-xxl-3 col-xl-5 col-lg-5 col-md-12 px-0   pb-0'>
                <SideBar tabContents='class' />
              </div>
              <div className='col-xxl-6 col-xl-7 col-lg-7 col-md-12' style={{ marginTop: '72px' }}>
                <div className='welcome_wrap '>
                  <div className='title-postion'>
                    <h1 className='small_title  pt-100 '>WELCOME</h1>
                    <div className='well_come_wrap align-items-center'>
                      <div className='uer_name'>
                        <h4 className='user_name'>
                          {/* {acceptInvite.map((data) => {
                            return ( */}
                          <div>
                            {' '}
                            <span className='bg_lit'>
                              {sectionData.createdBy.firstName} {sectionData.createdBy.lastName}{' '}
                            </span>
                            made you an instructor for{' '}
                            <span className='bg_lit'>
                              {sectionData?.classId?.courseName}, section {sectionData.sectionName}
                            </span>
                          </div>
                          {/*  );
                          })} */}
                        </h4>
                      </div>
                    </div>
                  </div>
                  <div className='col-lg-12'>
                    <div className='btn_Wrap mt-30'>
                      <button
                        style={{ marginTop: 60 }}
                        type='submit'
                        onClick={() => {
                          navigate('/TeacherAssistantSignup');
                          /* if (userToken) {
                          } else if (emailExist === 1) {
                            navigate("/teacherAssistantSignin", {
                              state: {sectionId: id},
                            });
                          } else if (emailExist === 0) {
                            navigate("/TeacherAssistantSignup");
                          } */
                        }}
                        className='btn_black_theme w-100 d-block'
                        disabled={loading ? true : false}
                      >
                        {loading ? (
                          <div className='loader'>
                            <Loader />
                          </div>
                        ) : (
                          ' Accept Invite'
                        )}
                      </button>
                      {/* <ToastContainer /> */}
                    </div>
                  </div>
                  <div className='col-12'>
                    {!userToken ? (
                      <div className='footer_bottom'>
                        <p className='have-account'>
                          Already have an account?{' '}
                          <a
                            className='have-account'
                            onClick={(e) => {
                              navigate('/teacherassistantsignin', {
                                state: { sectionId: id },
                              });
                            }}
                          >
                            Sign in
                          </a>
                        </p>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};
